import PropTypes from 'prop-types';
import React from 'react';
import className from 'classnames';

import CommentActions from '../../containers/comment-actions';
import CommentAvatar from '../comment-avatar';
import MoreButton from '../more-button';
import TimeAgo from '../time-ago';
import TopComment from '../top-comment';
import styles from './comment-header.scss';
import withEnvironment from '../../hoc/with-environment';

const renderMoreButton = (doRender, comment) => {
  const moreButtonId = `more-button-${comment._id}`;

  if (doRender) {
    return (
      <div className={styles.moreButton}>
        <MoreButton id={moreButtonId}>
          <CommentActions comment={comment} focusOnCloseId={moreButtonId}/>
        </MoreButton>
      </div>
    );
  }
};

const CommentHeader = ({ type, comment, showMoreButton, navigation: { ProfileLink }, showTopComment }) =>
  <div
    className={className(
      styles.commentHeader,
      styles[type],
      { [styles.withMoreButton]: showMoreButton },
      'comment-header'
    )}
  >
    <object type="communities/link" className={styles.commentAvatar}>
      <ProfileLink user={comment.owner}>
        <CommentAvatar user={comment.owner} type={type}/>
      </ProfileLink>
    </object>
    <span className={styles.commentTime}>
      <TimeAgo time={comment.createdDate}/>
    </span>
    {showTopComment && <TopComment/>}
    {renderMoreButton(showMoreButton, comment, showTopComment)}
  </div>;

CommentHeader.SEARCH = 'search';

CommentHeader.defaultProps = {
  showTopComment: false,
};

CommentHeader.propTypes = {
  type: PropTypes.string,
  comment: PropTypes.object.isRequired,
  showMoreButton: PropTypes.bool,
  navigation: PropTypes.object,
  showTopComment: PropTypes.bool,
};

export default withEnvironment({ navigation: 'navigation' })(CommentHeader);



// WEBPACK FOOTER //
// ./app/components/comment-header/comment-header.js